import React from 'react';

import getAlwaysLightModeCss from './styles/getAlwaysLightModeCss';

export type Props = React.ComponentPropsWithRef<'div'> & {
  /**
   * Custom tag to use for the root element
   *
   * @default div
   */
  component?: React.ElementType;
};

/**
 * Forces light color scheme for its subtree regardless of system preferences.
 */
const AlwaysLightMode = React.forwardRef(function AlwaysLightMode(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { component: Component = 'div', ...rest } = props;

  return <Component css={getAlwaysLightModeCss} {...rest} ref={ref} />;
});

export default AlwaysLightMode;
